import { useDisabledState } from 'common/disabled-context';
import { isImportedAndNotEndorseable } from 'core/helpers/policy-status';
import useSession from 'core/hooks/use-session';
import { useStore } from 'core/store';

/**
 * Whether payment-method add/update controls should be disabled.
 *
 * Staff must always be able to update how a policy will be paid, regardless of its cancellation
 * status (#34203) — e.g. to collect an outstanding balance on a cancelled / in-cancellation policy.
 * So, unlike the tab-wide `disabled` flag from the DisableContext (which folds in cancellation),
 * this intentionally does NOT treat cancellation as a blocker.
 *
 * It still blocks when the user lacks policy-edit permission, when an active hold card is present,
 * when the policy is imported-and-not-endorseable, or while endorsement drafting locks the policy.
 */
const usePaymentMethodDisabled = () => {
  const { canEditPolicies } = useSession();
  const { lockedByDrafting } = useDisabledState();
  const {
    account: {
      policies: {
        policy: { allActiveHoldCards, policy }
      }
    }
  } = useStore();

  return (
    !canEditPolicies ||
    !!allActiveHoldCards().length ||
    isImportedAndNotEndorseable(policy) ||
    Boolean(lockedByDrafting)
  );
};

export default usePaymentMethodDisabled;
